document.addEventListener("DOMContentLoaded", function() {
//seacrh bar logic
const openSearchPopup = document.getElementById("open-search-bar");
const openSearchMobilePopup = document.getElementById("open-search-bar_mobile");

const allHeaderArea = document.getElementById("shopify-section-header");
const mainSearchArea = document.getElementById("main-search"); 
const closeMainSearch = document.querySelectorAll(".main-search__close ");

const body = document.body;

function hideMainSearch() {
  mainSearchArea.style.visibility = "hidden";
  mainSearchArea.style.opacity = "0";
}

openSearchMobilePopup.addEventListener("click", () => {
  mainSearchArea.style.visibility = "visible";
  mainSearchArea.style.opacity = "1";
  body.classList.add("show-search");
})

openSearchPopup.addEventListener("click", () => {
  mainSearchArea.style.visibility = "visible";
  mainSearchArea.style.opacity = "1";
  body.classList.add("show-search");
})


closeMainSearch.forEach((button) => {
  button.addEventListener("click", () => {
    hideMainSearch()
})
}) 

document.addEventListener("click", (event) => {
  const isClickInsideMainSearch = allHeaderArea.contains(event.target);
  if (!isClickInsideMainSearch) {
    hideMainSearch();
  }
});
});

//1-1
const navTierWrapper1 = document.getElementById("NavigationTier-Wrapper-2-1");
const navigationTier3_1 = navTierWrapper1.querySelector("#NavigationTier3-1");

navigationTier3_1.addEventListener("mouseenter", function () {
  var megaMenuItem = navigationTier3_1.querySelector(".mega-menu__item_3");
  var megaMenuLink = navigationTier3_1.querySelector(
    ".navigation__column-title"
  );

  if (megaMenuItem) {
    megaMenuLink.style.fontWeight = "bold";
    megaMenuItem.style.display = "flex";
    megaMenuItem.style.marginLeft = "97px";
    megaMenuItem.style.zIndex = "9999";
    megaMenuItem.style.pointerEvents = "auto";
  }
});

navigationTier3_1.addEventListener("mouseleave", function () {
  var megaMenuItem = navigationTier3_1.querySelector(".mega-menu__item_3");
  var megaMenuLink = navigationTier3_1.querySelector(
    ".navigation__column-title"
  );

  if (megaMenuItem) {
    megaMenuLink.style.fontWeight = "400";
    megaMenuItem.style.display = "none";
    megaMenuItem.style.zIndex = "-1";
    megaMenuItem.style.pointerEvents = "none";
  }
});

//1-2
const navigationTier3_2 = navTierWrapper1.querySelector("#NavigationTier3-2");

navigationTier3_2.addEventListener("mouseenter", function () {
  var megaMenuItem = navigationTier3_2.querySelector(".mega-menu__item_3");
  var megaMenuLink = navigationTier3_2.querySelector(
    ".navigation__column-title"
  );

  if (megaMenuItem) {
    megaMenuLink.style.fontWeight = "bold";
    megaMenuItem.style.display = "flex";
    megaMenuItem.style.marginLeft = "137px";
    megaMenuItem.style.zIndex = "9999";
    megaMenuItem.style.pointerEvents = "auto";
  }
});

navigationTier3_2.addEventListener("mouseleave", function () {
  var megaMenuItem = navigationTier3_2.querySelector(".mega-menu__item_3");
  var megaMenuLink = navigationTier3_2.querySelector(
    ".navigation__column-title"
  );

  if (megaMenuItem) {
    megaMenuLink.style.fontWeight = "400";
    megaMenuItem.style.display = "none";
    megaMenuItem.style.zIndex = "0";
    megaMenuItem.style.pointerEvents = "none";
  }
});

// 1-3
const navigationTier3_3 = navTierWrapper1.querySelector("#NavigationTier3-3");
navigationTier3_3.addEventListener("mouseenter", function () {
  var megaMenuItem = navigationTier3_3.querySelector(".mega-menu__item_3");
  var megaMenuLink = navigationTier3_3.querySelector(
    ".navigation__column-title"
  );

  if (megaMenuItem) {
    megaMenuLink.style.fontWeight = "bold";

    megaMenuItem.style.display = "flex";
    megaMenuItem.style.marginLeft = "137px";
    megaMenuItem.style.zIndex = "9999";
    megaMenuItem.style.pointerEvents = "auto";
  }
});

navigationTier3_3.addEventListener("mouseleave", function () {
  var megaMenuItem = navigationTier3_3.querySelector(".mega-menu__item_3");
  var megaMenuLink = navigationTier3_3.querySelector(
    ".navigation__column-title"
  );

  if (megaMenuItem) {
    megaMenuLink.style.fontWeight = "400";
    megaMenuItem.style.display = "none";
    megaMenuItem.style.zIndex = "0";
    megaMenuItem.style.pointerEvents = "none";
  }
});

//1-4
const navigationTier3_4 = navTierWrapper1.querySelector("#NavigationTier3-4");
navigationTier3_4.addEventListener("mouseenter", function () {
  var megaMenuItem = navigationTier3_4.querySelector(".mega-menu__item_3");
  var megaMenuLink = navigationTier3_4.querySelector(
    ".navigation__column-title"
  );

  if (megaMenuItem) {
    megaMenuLink.style.fontWeight = "bold";

    megaMenuItem.style.display = "flex";
    megaMenuItem.style.marginLeft = "94px";
    megaMenuItem.style.zIndex = "9999";
    megaMenuItem.style.pointerEvents = "auto";
  }
});

navigationTier3_4.addEventListener("mouseleave", function () {
  var megaMenuItem = navigationTier3_4.querySelector(".mega-menu__item_3");
  var megaMenuLink = navigationTier3_4.querySelector(
    ".navigation__column-title"
  );

  if (megaMenuItem) {
    megaMenuLink.style.fontWeight = "400";

    megaMenuItem.style.display = "none";
    megaMenuItem.style.zIndex = "0";
    megaMenuItem.style.pointerEvents = "none";
  }
});

//1-5
const navigationTier3_5 = navTierWrapper1.querySelector("#NavigationTier3-5");
navigationTier3_5.addEventListener("mouseenter", function () {
  var megaMenuItem = navigationTier3_5.querySelector(".mega-menu__item_3");
  var megaMenuLink = navigationTier3_5.querySelector(
    ".navigation__column-title"
  );

  if (megaMenuItem) {
    megaMenuLink.style.fontWeight = "bold";

    megaMenuItem.style.display = "flex";
    megaMenuItem.style.marginLeft = "94px";
    megaMenuItem.style.zIndex = "9999";
    megaMenuItem.style.pointerEvents = "auto";
  }
});

navigationTier3_5.addEventListener("mouseleave", function () {
  var megaMenuItem = navigationTier3_5.querySelector(".mega-menu__item_3");
  var megaMenuLink = navigationTier3_5.querySelector(
    ".navigation__column-title"
  );

  if (megaMenuItem) {
    megaMenuLink.style.fontWeight = "400";

    megaMenuItem.style.display = "none";
    megaMenuItem.style.zIndex = "0";
    megaMenuItem.style.pointerEvents = "none";
  }
});


//1-6
const navigationTier3_6 = navTierWrapper1.querySelector("#NavigationTier3-6");
navigationTier3_6.addEventListener("mouseenter", function () {
  var megaMenuItem = navigationTier3_6.querySelector(".mega-menu__item_3");
  var megaMenuLink = navigationTier3_6.querySelector(
    ".navigation__column-title"
  );

  if (megaMenuItem) {
    megaMenuLink.style.fontWeight = "bold";

    megaMenuItem.style.display = "flex";
    megaMenuItem.style.marginLeft = "94px";
    megaMenuItem.style.zIndex = "9999";
    megaMenuItem.style.pointerEvents = "auto";
  }
});

navigationTier3_6.addEventListener("mouseleave", function () {
  var megaMenuItem = navigationTier3_6.querySelector(".mega-menu__item_3");
  var megaMenuLink = navigationTier3_6.querySelector(
    ".navigation__column-title"
  );

  if (megaMenuItem) {
    megaMenuLink.style.fontWeight = "400";

    megaMenuItem.style.display = "none";
    megaMenuItem.style.zIndex = "0";
    megaMenuItem.style.pointerEvents = "none";
  }
});


//another logic
// const navigationLinks = navigationTier3_1.querySelectorAll(".navigation__link");
// const navigationLinksWrapper = navigationTier3_1.querySelector(
//   ".navigation__tier-3"
// );

// const megaMenuItem = document.querySelector(".mega-menu__item_3");

// const link1 = navigationTier3_1.querySelector("#link-1");
// navigationLinksWrapper.addEventListener("mouseenter", () => {
//   if ((megaMenuItem.display = "flex")) {
//     megaMenuItem.display = "flex";
//     link1.style.fontWeight = "900";
//   }
// });

// navigationLinksWrapper.addEventListener("mouseenter", () => {
//   megaMenuItem.display = "none";
//   link1.style.fontWeight = "400";
// });

// let item1 = document.getElementById("NavigationTier3-1");
// let itemLi1 = item1.querySelector("li");
// let itemA1 = item1.querySelector("a");
// itemA1.setAttribute(
//   "data-image",
//   "https://cdn.shopify.com/s/files/1/0902/6602/files/rings-min.png?v=1698148621"
// );

// let item2 = document.getElementById("NavigationTier3-2");
// let itemLi2 = item2.querySelector("li");
// let itemA2 = itemLi2.querySelector("a");
// itemA2.setAttribute(
//   "data-image",
//   "https://cdn.shopify.com/s/files/1/0902/6602/files/earrings-min.png?v=1698148621"
// );

// let item3 = document.getElementById("NavigationTier3-3");
// let itemLi3 = item3.querySelector("li");
// let itemA3 = itemLi3.querySelector("a");

// itemA3.setAttribute(
//   "data-image",
//   "https://cdn.shopify.com/s/files/1/0902/6602/files/mega-muni-item-min.png?v=1699366684"
// );

// let item4 = document.getElementById("NavigationTier3-4");
// let itemLi4 = item4.querySelector("li");
// let itemA4 = itemLi4.querySelector("a");
//   itemA4.setAttribute(
//     "data-image",
//     "https://cdn.shopify.com/s/files/1/0902/6602/files/bracelets-min.png?v=1698148621"
//   );

// const mainImage = document.querySelector(".mega-menu__main-image");
// const originalImageSrc = mainImage.src;
// item1.addEventListener("mouseenter", () => {
//   const imageSrc = itemA1.getAttribute("data-image");
//   mainImage.src = imageSrc;

//   mainImage.classList.add("mega-menu__main-image_animation");

//   setTimeout(() => {
//     mainImage.classList.remove("mega-menu__main-image_animation");
//   }, 4500);
// });

// item1.addEventListener("mouseleave", () => {
//   mainImage.src = originalImageSrc;
// });

// itemA2.addEventListener("mouseenter", () => {
//   const imageSrc = itemA2.getAttribute("data-image");
//   mainImage.src = imageSrc;

//   mainImage.classList.add("mega-menu__main-image_animation");

//   setTimeout(() => {
//     mainImage.classList.remove("mega-menu__main-image_animation");
//   }, 4500);
// });

// itemA2.addEventListener("mouseleave", () => {
//   mainImage.src = originalImageSrc;
// });

// itemA3.addEventListener("mouseenter", () => {
//   const imageSrc = itemA3.getAttribute("data-image");
//   mainImage.src = imageSrc;

//   mainImage.classList.add("mega-menu__main-image_animation");

//   setTimeout(() => {
//     mainImage.classList.remove("mega-menu__main-image_animation");
//   }, 4500);
// });

// itemA3.addEventListener("mouseleave", () => {
//   mainImage.src = originalImageSrc;
// });

// itemA4.addEventListener("mouseenter", () => {
//   const imageSrc = itemA4.getAttribute("data-image");
//   mainImage.src = imageSrc;
//   mainImage.classList.add("mega-menu__main-image_animation");

//   setTimeout(() => {
//     mainImage.classList.remove("mega-menu__main-image_animation");
//   }, 4500);
// });

// itemA4.addEventListener("mouseleave", () => {
//   mainImage.src = originalImageSrc;
// });
